module.exports = __webpack_public_path__ + "img/rating.dc678320.png";